import { httpRequest } from "../../http";
import { EngagementAction } from "@models/engagementAction";
import { EngagementActionSerializer } from "@models/serializers/engagementActionSerializer";

export class CommandRequestChangesAction {
  async run(engagementId: number, actionId: number): Promise<EngagementAction> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/actions/${actionId}/request-changes/`;
    const response = await httpRequest<any>(url, { method: "POST" });
    return new EngagementActionSerializer().deserialize(response);
  }
}
